/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-2016 Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React, { Component } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './Footer.css';
import { Link } from 'react-router';
import fetch from '../../core/fetch';
import $ from 'jquery';

var validate = '';


@withStyles(s)
export default class Footer extends Component {

    constructor(props) {
        super(props);

        this.state = {
            footer: [],
            formData: [],
            nom: '',
            courriel: '',
            success: false,
            validate: false,
            error: false,
        };
        

        this.updateStateCourriel = this.updateStateCourriel.bind(this);
        this.submitForm = this.submitForm.bind(this);
        this.validateInput = this.validateInput.bind(this);

    }

    componentDidMount(){

        this.GetFooter();
    }

    updateStateCourriel(e) {
      
        this.setState({courriel: e.target.value});

    }

    validateInput() {

        validate = false;

        if(this.refs.courriel.value == ''){
            self = this.refs.courriel;
            $(self).addClass('borderRed');
            validate = !this.state.validate;
        }
        if(this.refs.courriel.value != ''){
            self = this.refs.courriel;
            $(self).removeClass('borderRed');
        }
        
        if(validate) {
            $('.messageError').css('color', 'red');
        }

        return validate;
    }

    submitForm(e){

        e.preventDefault();

        validate = this.validateInput();

        var form = document.getElementById('formInfolettre');
        var formData = new FormData(form);
        var url = 'http://agenceprolifik.ca/graphql/index.php'

        
        if(validate){

            
        }
        else{

            $.ajax({
                url: url,
                type: "POST",
                data: formData,
                mimeType: "multipart/form-data",
                contentType: false,
                crossDomain: true,
                dataType: "json",
                cache: false,
                processData:false,
                success: function(data, textStatus, jqXHR)
                {
                    
                    this.setState({success: true});

                }.bind(this),
                error: function(jqXHR, textStatus, errorThrown) 
                {

                    console.log('echec');

                }.bind(this)          
            });
        }
    }

    async GetFooter(){
        const resp = await fetch('/graphql', {
            method: 'post',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                query: '{footer{id, slug, title, content, colonne1, colonne2, colonne3}}',
            }),
            credentials: 'include',
        });
        const { data } = await resp.json();
        if (!data || !data.footer) throw new Error('Erreur sur le chargement du footer !');
        
        this.setState({ footer: data.footer })
    }

    render(){
        const contentFooter = <div dangerouslySetInnerHTML={{ __html: this.state.footer.content }} />
        const colonne1 = <div dangerouslySetInnerHTML={{ __html: this.state.footer.colonne1 }} />
        const colonne2 = <div dangerouslySetInnerHTML={{ __html: this.state.footer.colonne2 }} />
        const colonne3 = <div dangerouslySetInnerHTML={{ __html: this.state.footer.colonne3 }} />

        if(!this.state.success){

            var form =  <form id="formInfolettre" onSubmit={this.submitForm}>
                            <div className={`wrapInput`}>
                                <input type="hidden" name="infolettre" />
                                <input type="hidden" name="nom" />
                                <input type="email" name="courriel" id="courriel" ref="courriel" className={`inputText`} placeholder="@ Entrer votre courriel" onChange={this.updateStateCourriel} value={this.state.courriel} />
                                <input type="submit" className={`inputSubmit carre`} value="" />
                            </div>
                        </form>
                        
        }
        else{
            var form =  <span className={`confirm`}>Merci de votre intérêt !</span>
        }

        return (
            <div className={s.root}>
                <footer id="footer" className={`footer`}>
                    <div className={`container`}>
                        <div className={`topFooter`}>
                            <div className={`wrapNav`}>
                                <ul>
                                    <li><Link to="/strategie-web">Attirer</Link></li>
                                    <li><Link to="/developpement-web">Convertir</Link></li>
                                    <li><Link to="/service-conseil">Entretenir</Link></li>
                                </ul>
                            </div>
                        </div>
                        <div className={`middleFooter`}>
                            {colonne1}
                            <div className={`footerCol col-xs-12 col-md-4`}>
                                <div className={`content`}>
                                    <span className={`titreFooter`}>Inscrivez-vous<br />à l`infolettre Prolifik</span>
                                    <div className={`texteFooter`}>
                                        <p>Recevez nos conseils et guides pratiques en stratégie web en exclusivité !</p><br />
                                    </div>
                                    <div className={`wrapForm`}>
                                        {form}
                                    </div>
                                </div>
                            </div>
                            {colonne3}
                        </div>
                        <div className={`bottomFooter`}>
                            <div className={`copyright`}>© 2016 - Agence Prolifik - Stratégie web pour PME</div>
                        </div>
                    </div>
                </footer>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./components/Footer/Footer.js